import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReferralsDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getReferralCode = createAsyncThunk<
  string,
  string,
  { dispatch: ReferralsDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_REFERRAL_CODE, async (userId, { extra }) => {
  return await extra.referralsRepo.getReferralCode(userId);
});
